import * as React from "react";
import { StyleSheet, View } from "react-native";
import { useTheme, List, Paragraph, Divider } from "react-native-paper";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { Block } from "@block";
import { StackActions, useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { ScrollView } from "react-native-gesture-handler";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import listAnswerQuestions from "../__test__/list-answer-questions.json";
import { StackSpacing } from "app/shared/components/spacing";
import EntypoIcons from "@expo/vector-icons/Entypo";

interface ItemAswQuesProps {
  vi: string;
  en: string;
}

interface ItemChildren {
  answer: ItemAswQuesProps;
  question: ItemAswQuesProps;
}

interface ItemList {
  id: string;
  group: ItemAswQuesProps;
  children: ItemChildren[];
}

const AnswerQuestions = () => {
  const { colors, fonts } = useTheme();
  const { t, i18n } = useTranslation();
  const { dispatch } = useNavigation();
  const isDesktop = useDesktopMediaQuery();

  const onCancel = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const onGoBack = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_ABOUT_US));
  };

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        titleGroup: { ...fonts.medium, color: colors.text },
        titleAnswer: { ...fonts.regular, color: colors.accent, marginLeft: spacing.massive },
        titleQuestion: {
          ...fonts.regular,
          color: colors.text,
          paddingBottom: spacing.small,
          paddingLeft: spacing.macro - spacing.micro,
          paddingRight: spacing.galactic - spacing.micro,
        },
        iconQuestion: { position: "absolute", top: 0 },
      }),
    [colors, fonts],
  );

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onCancel(),
    },
    {
      name: t("SETTING_PV_ONLINE_BANKING"),
      onPressSubtitle: () => onGoBack(),
    },
    {
      name: t("SETTING_CAU_HOI_THUONG_GAP"),
      onPressSubtitle: () => {},
    },
  ];

  const renderListChildren = (_item: ItemChildren, _index: number, _lenth: number) => (
    <View key={String(_index)}>
      <List.AccordionGroup key={String(_index)}>
        <List.Accordion
          id={String(_index)}
          key={String(_index)}
          title={i18n.language === "vi" ? _item.answer.vi : _item.answer.en}
          titleNumberOfLines={10}
          titleStyle={styles.titleAnswer}
          style={{ backgroundColor: colors.surface }}
          left={() => <EntypoIcons name="dot-single" size={spacing.massive} color={colors.accent} style={styles.iconQuestion} />}>
          <Paragraph style={styles.titleQuestion}>{i18n.language === "vi" ? _item.question.vi : _item.question.en}</Paragraph>
        </List.Accordion>
      </List.AccordionGroup>
      {_index === _lenth - 1 ? null : <Divider />}
    </View>
  );

  const renderListGroup = (_item: ItemList, _index: number) => (
    <Block key={String(_index)}>
      <List.Accordion
        key={String(_index)}
        title={i18n.language === "vi" ? _item.group.vi : _item.group.en}
        id={_item.id}
        titleStyle={styles.titleGroup}>
        {_item.children.map((item, index) => renderListChildren(item, index, _item.children.length))}
      </List.Accordion>
      <StackSpacing size="tiny" />
    </Block>
  );

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SETTING_CAU_HOI_THUONG_GAP")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <List.AccordionGroup>{listAnswerQuestions.list.map((item, index) => renderListGroup(item, index))}</List.AccordionGroup>
        </Block>
      </ScrollView>
    </Block>
  );
};

export default AnswerQuestions;
